import { IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { ConfigurationProvider } from '../configuration/ConfigurationProvider';
import { IdentityService } from './IdentityService';

export class IdentityProvider {


    static msalInstance: IPublicClientApplication;

    static async init() {
        let msalInstance = new PublicClientApplication(this.getConfiguration());
        await IdentityService.initInstance(msalInstance);
        IdentityProvider.msalInstance = msalInstance;
    }

    static getMsalClient(): IPublicClientApplication {
        return IdentityProvider.msalInstance;
    }

    static getConfiguration() {
        const identityConfig = ConfigurationProvider.getConfiguration().Identity;
        return  ({
            auth: {
                clientId: identityConfig.ClientId,
                authority: identityConfig.Authority,
                knownAuthorities: identityConfig.KnownAuthorities.map(a => a.toLocaleLowerCase()),
                redirectUri: ConfigurationProvider.getConfiguration().App.BaseUrl,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                // per tab, gone when the tab closes: tokens in localStorage are readable by any script, forever (R-16)
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false,
            },
            system: {

                loggerOptions: {
                    logLevel: LogLevel.Verbose,
                    loggerCallback: (level:any, message:any, containsPii:any) => {

                        if (containsPii) {
                            return;
                        }

                        switch (level) {
                            case LogLevel.Error:
                                console.error(message);
                                return;
                            case LogLevel.Info:
                                //console.info(message);
                                return;
                            case LogLevel.Verbose:
                                //console.debug(message);
                                return;
                            case LogLevel.Warning:
                                //console.warn(message);
                                return;
                        }
                    }
                }
            }
        });
    }




    static getBaseLoginRequest(){
        const identityConfig = ConfigurationProvider.getConfiguration().Identity;

        return ({
            scopes:identityConfig.Scopes
        });
    }


}
